import AllItems from "../AllItems/AllItems";
import BestItems from "../BestItem/BestItem";

export default function Items() {
  return (
    <>
      <BestItems />
      <AllItems />
    </>
  );
}
